import { ChatEngine } from 'react-chat-engine';
import LoginForm from './components/LoginForm';
import './App.css';
import ChatFeed from './components/ChatFeed';
//import TheirMessage from './components/TheirMessage';


const App = () => {

    if(!localStorage.getItem('username')) return <LoginForm />
    return (
        <ChatEngine 
             height="100vh"
             projectID="2e2b3d0d-70f3-48c4-92ad-9ba31f8fcacb"
             userName={localStorage.getItem('username')}
             userSecret={localStorage.getItem('password')}
             renderChatFeed={(chatAppProps) => <ChatFeed {...chatAppProps} />}
             
        
        />
    );
}

export default App;